export default "__VITE_ASSET__CFkgFFGK__"